import { Link } from "react-router-dom";
import { useLang } from "../i18n";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="bg-bark text-parchment/80 mt-24" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-4">
            <img src="/logo.png" alt="LoMIELlina" className="h-16 w-16 rounded-full shadow-lg shadow-black/40" />
            <p className="font-serif text-3xl font-bold text-parchment">Lo<span className="text-gold">MIEL</span>lina</p>
          </div>
          <p className="mt-4 text-sm text-parchment/60 max-w-sm leading-relaxed">{t("footer.tagline")}</p>
          <p className="mt-6 font-mono text-xs tracking-widest text-gold/80">45.18°N, 8.72°E — LOMELLINA, PV</p>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-gold mb-4">{t("footer.shop")}</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop" className="hover:text-gold transition-colors" data-testid="footer-shop-link">{t("nav.shop")}</Link></li>
            <li><Link to="/shop?cat=regalo" className="hover:text-gold transition-colors" data-testid="footer-gift-link">{t("cat.regalo")}</Link></li>
            <li><Link to="/corsi" className="hover:text-gold transition-colors" data-testid="footer-courses-link">{t("nav.courses")}</Link></li>
          </ul>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-gold mb-4">{t("footer.contacts")}</p>
          <ul className="space-y-2 text-sm text-parchment/60">
            <li>info@lomiellina.it</li>
            <li>+39 0384 000 000</li>
            <li>Lomellina (PV), Italia</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <p className="max-w-7xl mx-auto px-5 sm:px-8 py-5 text-xs text-parchment/40">{t("footer.rights")}</p>
      </div>
    </footer>
  );
}
